import React from "react";
import DepartmentList from "../../components/features/departments/DepartmentList";

const DepartmentsPage = () => {
  return <DepartmentList />;
};

export default DepartmentsPage;
